import config from './config-media';
import * as firebaseMedia from 'firebase';

const appMedia = firebaseMedia.initializeApp(config.firebaseConfig, "firebase-media");
export const authMedia = firebaseMedia.auth(appMedia);
export const databaseMedia = firebaseMedia.database(appMedia);



// WEBPACK FOOTER //
// ./src/firebase/firebase-app-media.js